import React, { useEffect, useState } from "react";
import { useLang } from "@/context/LanguageContext";
import { api } from "@/lib/api";
import { PageShell, PageHero } from "@/components/layout/PageShell";
import { OfficeBearerCard } from "@/components/common/OfficeBearerCard";
import { ChevronDown, ChevronUp } from "lucide-react";

const Grid = ({ members }) => (
  <div className="grid grid-cols-2 gap-5 sm:grid-cols-3 lg:grid-cols-4">
    {members.map((m, i) => <OfficeBearerCard key={i} bearer={{ ...m, order: i }} />)}
  </div>
);

const OfficeBearers = () => {
  const { t, lang } = useLang();
  const [data, setData] = useState(null);
  const [openPast, setOpenPast] = useState(false);
  useEffect(() => { api.committees().then(setData).catch(() => setData({ current: null, past: [] })); }, []);

  const current = data?.current;
  const past = data?.past || [];
  const L = (c) => (lang === "gu" ? (c.name_gu || c.name_en) : c.name_en);

  return (
    <PageShell>
      <PageHero title={t("bearersTitle")} subtitle={t("bearersSubtitle")} />
      <div className="gmoaa-container py-12">
        {current ? <Grid members={current.members} /> : <p className="text-gmoaa-text-muted">Committee will be published soon.</p>}

        {past.length > 0 && (
          <div className="mt-12">
            <button onClick={() => setOpenPast((o) => !o)} data-testid="previous-committees-toggle"
              className="flex items-center gap-2 rounded-lg border border-gmoaa-border-subtle bg-white px-4 py-2.5 text-sm font-medium text-gmoaa-green hover:bg-gmoaa-green-light">
              Previous committees {openPast ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
            </button>
            {openPast && (
              <div className="mt-6 space-y-10" data-testid="previous-committees">
                {past.map((c) => (
                  <div key={c.id}>
                    <h3 className="mb-4 font-serif text-xl font-semibold text-gmoaa-green">
                      {L(c)} {c.term_start && <span className="text-sm font-normal text-gmoaa-text-muted">· {c.term_start?.slice(0, 4)}–{c.term_end?.slice(0, 4)}</span>}
                    </h3>
                    <Grid members={c.members} />
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </div>
    </PageShell>
  );
};

export default OfficeBearers;
